// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__14cve","title":"Header_title__2oqHK","side":"Header_side__1YO8d"};